// Action Creators
// Constants
import { PlanType } from "@ms/uno-constants/lib/local/AppConstants";
import { ModalType } from "@ms/uno-constants/lib/local/ModalType";
/** Opens linked-plan creation when the feature is enabled for a Unified source plan. */ export const openCreatePlanFromTaskModal = (isCreatePlanFromTaskEnabled, sourceTaskId, sourcePlan, modalActionCreator, onDismiss)=>{
    if (!isCreatePlanFromTaskEnabled || sourcePlan?.getPlanType() !== PlanType.Unified) {
        return;
    }
    const modalData = {
        modalType: ModalType.CreatePlan,
        showCreateNewPremium: false,
        sourceTaskId,
        sourcePlanId: sourcePlan.id,
        sourcePlanDisplayName: sourcePlan.displayName,
        onDismiss
    };
    modalActionCreator.openModal(modalData);
};
